import { AfterViewInit, Directive, ElementRef } from '@angular/core';

@Directive({
    selector: '[wfdssInputAutoFocus]',
    standalone: false
})
export class InputAutoFocusDirective implements AfterViewInit {

  constructor(private el: ElementRef) {
  }

  ngAfterViewInit() {
    if (this.el.nativeElement) {
      this.el.nativeElement.focus();
    }
  }

}